import { useSearchParams } from 'react-router-dom';
import { activeEntryKey } from './activeEntryKey';
import type { IMenuSection } from './IMenuSection';
import { libraryModeParam } from './libraryModes';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/** Ключ активного пункту меню типу запису за поточною адресою (activeEntryKey): маршрут, `?item=` і `?mode=`. */
export function useActiveEntryKey(rtKey: string, sections: IMenuSection[]): string | null {
  const route = useWorkspaceParams();
  const [params] = useSearchParams();
  return activeEntryKey(rtKey, sections, route, params.get('item'), params.get(libraryModeParam));
}
